import logo from './logo.svg';
import './App.css';
import ImageAdd from './components/ImageAdd.js';

function App() {




  return (
    <div className="App">
      <header className="App-header">

        <ImageAdd />

      </header>
    </div>
  );
}

export default App;
